import React from 'react';
import { Skeleton } from '@material-ui/lab';
import './SkeletonCard.css';

const SkeletonCard = ({ children }) => (
  <div className="course-item">
    <a
      data-gtm-type="click"
      data-gtm-clicktype="card"
    >
      <Skeleton
        variant="rect"
        style={{ maxWidth: "initial" }}
      >
        {children}
      </Skeleton>
      <Skeleton id="skeletonText" variant="text" width="70%" />
    </a>
  </div>
);

export default SkeletonCard;



// WEBPACK FOOTER //
// ./src/components/Skeleton/SkeletonCard.jsx